export default __webpack_public_path__ + "static/media/outIconDark.3fc5981a.svg";